import { render, staticRenderFns } from "./FillImageColor.vue?vue&type=template&id=5c801ac7&scoped=true"
import script from "./FillImageColor.vue?vue&type=script&lang=js"
export * from "./FillImageColor.vue?vue&type=script&lang=js"
import style0 from "./FillImageColor.vue?vue&type=style&index=0&id=5c801ac7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c801ac7",
  null
  
)

export default component.exports